import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Button, Label, TabBar, TabItem } from '../components';
import cn from 'classnames';
import styles from './LandscapeStoryBaseEditTemplate.module.css';

interface OrganizationBaseEditTemplateProps {
  children: React.ReactNode;
}

const OrganizationBaseEditTemplate: React.FC<
  OrganizationBaseEditTemplateProps
> = ({ children }) => {
  const navigate = useNavigate();
  const { organizationId } = useParams();
  const location = useLocation();

  return (
    <div>
      <div className={cn(styles.heading)}>
        <Label content="Organization" size="lg" />
        <Button
          className={styles.buttonLink}
          onClick={() => navigate(`/organizations`)}
          variant="link"
        >
          Go back to overview
        </Button>
      </div>
      <TabBar
        onSelect={(id: string | null) => {
          if (id) {
            navigate(id);
          }
        }}
        defaultSelected={location.pathname}
      >
        <TabItem
          title="Organization"
          id={`/organizations/edit/${organizationId}`}
        />
        <TabItem
          title="Content Blocks"
          id={`/organizations/edit/${organizationId}/content-blocks`}
        />
        <TabItem
          title="Documents"
          id={`/organizations/edit/${organizationId}/documents`}
        />
        <TabItem
          title="Commodities"
          id={`/organizations/edit/${organizationId}/commodities`}
        />
        <TabItem
          title="Landscapes"
          id={`/organizations/edit/${organizationId}/landscapes`}
        />
      </TabBar>
      <main>{children}</main>
    </div>
  );
};

export default OrganizationBaseEditTemplate;
